import React, { useContext } from 'react';
import { useTranslatableField } from '@/utils/useTranslatableField';
import Head from 'next/head';
import { SurveyType } from 'types/survey';
import { PageContext } from 'src/context/PageContext';
import { buildPublicUrlFromSlug } from 'utils/publicUrlRule';

interface SurveyProps {
  survey: SurveyType;
}
export function SurveyOpenGraph(props: SurveyProps): JSX.Element | null {
  const { survey } = props;
  const { slug, canonicalHostname } = useContext(PageContext);
  const { translateField } = useTranslatableField(slug?.[1]);
  return (
    <Head>
      <meta property="og:title" content={translateField(survey.title_for_display)} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={slug[1]} />
      <meta property="og:url" content={buildPublicUrlFromSlug(slug, canonicalHostname)} />
      <meta property="og:description" content={translateField(survey?.configuration?.description)} />
      <meta property="og:image" content={translateField(survey?.configuration?.image)} />
    </Head>
  );
}
